export const API_URL =
  "https://fp6gps6hf5.execute-api.eu-west-1.amazonaws.com/api";
export const REFRESH_TOKEN_URL =
  "https://fp6gps6hf5.execute-api.eu-west-1.amazonaws.com/api/auth/refresh";
